import CONFIG from './default';

export default {
  ...CONFIG,
  API_ROOT: 'https://bml.ffit.lv/api/'
};



// WEBPACK FOOTER //
// ./src/config/production.js